<template>
  <el-dialog
    :title="!showIdentity2 ? '欢迎来到爱原物' : '请选择你关注的'"
    :visible.sync="showIdentity"
    :width="!showIdentity2 ? '790px' : '485px'"
    :close-on-click-modal="false"
    append-to-body
    :show-close="false" :custom-class="!showIdentity2 ? 'el-dialog-new-identity' : 'el-dialog-new-identity-2'">
    <section class="new-identity">

      <div class="ID" v-if="!showIdentity2">
        <!-- 身份类型 0：买家 1:设计师 2:买家和设计师 -->
        <p class="label-name">您的身份是？</p>
        <div class="select-ID-ID">
          <div :class="['select-ID-ID-info', {'active': selectIdentityID.some(item => item === 0)}]"
               @click="selectIdentity(0)">
            <p class="in">我是需求方<span>（设计/买图）</span></p>
            <p class="explain">寻找设计服务，购买正版图案，申请知产服务</p>
            <div class="icon"></div>
          </div>
          <div :class="['select-ID-ID-info', {'active': selectIdentityID.some(item => item === 1)}]"
               @click="selectIdentity(1)">
            <p class="in">我是设计师<span>（接单/卖图）</span></p>
            <p class="explain">提供设计服务，做任务接单、卖图赚钱</p>
            <div class="icon"></div>
          </div>
        </div>
        <p class="label-name">为了更精准的为您服务，请选择您是？</p>
        <div class="select-ID-radio">
          <div v-for="item in IDObj" :key="item.key" @click="changeID(item.key)">
            <span :class="['icon', {'Not_selected' : ID !== item.key}]">
              <img v-if="ID === item.key" :src="ID === item.key ? icon : ''" alt="" />
            </span>
            <span class="text">{{ item.name }}</span>
          </div>
        </div>
      </div>

      <div class="ServiceType" v-else>
        <el-form ref="form" :model="form" label-width="82px">
          <el-form-item v-if="selectIdentityID.some(item => item === 1)">
            <span slot="label">服务类型：</span>
            <el-cascader
              v-model="form.type"
              placeholder="请选择"
              collapse-tags
              :show-all-levels="false"
              clearable
              class="el-select-1"
              :options="service"
              :props="{ multiple: true, value: 'id', label: 'title' }"
              @change="changeCascader1"
              filterable></el-cascader>
            <span class="tips">{{ form.type.length }}/10</span>
          </el-form-item>
          <el-form-item>
            <span slot="label" class="new-label"><span>市</span><span>场：</span></span>
            <el-select v-model="form.service" :class="form.service === 3 ? 'el-select-2' : 'el-select-1'" @change="changeService">
              <el-option
                v-for="item in serverObj"
                :key="item.key"
                :label="item.name"
                :value="item.key">
              </el-option>
            </el-select>
            <el-cascader
              v-if="form.service === 3"
              v-model="form.region"
              placeholder="请选择地区"
              collapse-tags
              :show-all-levels="false"
              clearable
              class="el-select-3"
              :options="typeObj"
              :props="{ multiple: true, value: 'id', label: 'chLabel' }"
              @change="changeRegion"
              filterable></el-cascader>
          </el-form-item>
          <el-form-item>
            <span slot="label" class="new-label"><span>行</span><span>业：</span></span>
            <el-cascader
              v-model="form.industry"
              placeholder="请选择"
              collapse-tags
              :show-all-levels="false"
              clearable
              class="el-select-4"
              popper-class="el-select-4-popper"
              :options="industry"
              :props="{ multiple: true, value: 'id', label: 'title' }"
              @change="changeIndustry"
              filterable></el-cascader>
          </el-form-item>
        </el-form>
      </div>

    </section>
    <span slot="footer" class="dialog-footer">
      <el-button v-if="!showIdentity2" type="primary" @click="nextStep">下一步</el-button>
      <el-button v-if="showIdentity2" type="text" class="skip" @click="submit(false)" :loading="btnLoading">跳过</el-button>
      <div v-if="showIdentity2">
        <el-button @click="previousStep">上一步</el-button>
        <el-button type="primary" @click="submit(true)" :loading="btnLoading">开启爱原物之旅</el-button>
      </div>
    </span>
  </el-dialog>

</template>

<script>
  import {getByKeys, getCityList, updateUserInfo, saveInformation} from "../../../api/accountManage";
  import { getTreeData, setCascaderData } from "../../../tool";

  export default {
    name: "dialogCom",
    props: {
      showIdentity: {
        type: Boolean,
        default: false
      },
      showIdentity2: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      showIdentity2(val) {
        if (val) {
          this.getByKeysData();
        }
      }
    },
    data() {
      return {
        btnLoading: false, // 按钮loading状态
        ID: 0, // 个人/企业
        IDObj: [
          { key: 1, name: "个人" },
          { key: 2, name: "企业" }
        ], // 是否认证企业号或个人号，1个人，2企业
        selectIdentityID: [], // 设计服务商/买家 // 身份类型 0买家1:设计师 2:买家和设计师
        icon: require("../../../assets/img@2x/Select.png"),
        selectNum: 0,
        serviceType: 3,
        serverObj: [
          { key: 2, name: "内销" },
          { key: 3, name: "外销" },
          { key: 1, name: "不区分" }
        ],
        typeObj: [], // 地区
        form: {
          type: [],
          service: 1, // 市场类型，0未设置，1非典型，2内销，3外销
          industry: [], // 行业
          region: [] // 地区
        },
        industry: [], // 行业
        service: [], // 服务类型数据
        copyTyope: [], // 服务类型数据
        copyRegionTyope: [], // 地区数据
        designer: false, // 是否设计师
        obj: {},
        copyIndustry: [] // 选中行业数据
      }
    },
    computed: {},
    methods: {
      // 行业
      changeIndustry() {
        if (this.form.industry && this.form.industry.length) {
          let arr = [];
          this.form.industry.forEach(e => {
            arr.push(e[1]);
          });
          let is = new Set(arr).size > 3; // 二级选项限制3个以内
          if (is) {
            this.form.industry = this.copyIndustry;
            this.messageWarning("行业最多可以选择3个");
          }
          this.copyIndustry = JSON.parse(JSON.stringify(this.form.industry));
        }
       
      },
      // 地区
      changeRegion() {
        if (this.form.region.length > 50) {
          this.form.region = this.copyRegionTyope;
          this.messageWarning("最多可以选择50个地区");
        }
        this.copyRegionTyope = JSON.parse(JSON.stringify(this.form.region));
      },
      submit(bool) {
        this.obj = {
          market: {
            type: this.form.service
          }
        };
        if (bool) {
          let { type, service, industry, region } = this.form;
          // if (this.designer && !type.length) {
          //   this.messageWarning("请选择您关注的服务类型");
          //   return;
          // } else if (service === 3 && !region.length) {
          //   this.messageWarning("请选择您的外销市场地区");
          //   return;
          // } else if (!industry.length) {
          //   this.messageWarning("请选择您关注的行业");
          //   return;
          // }
          this.obj = {
            serviceIds: this.setCascaderIndustryData(type),
            market: {
              type: service,
              area: setCascaderData(this.typeObj, ["areaCode", "areaName"], region)
            },
            industryIds: this.setCascaderIndustryData(industry)
          };
        }
        this.setIndentity();
      },
      // 设置身份
      async setIndentity() {
        this.btnLoading = true;
        let obj = {
          identity: this.selectIdentityID.length > 1 ? 2 : this.selectIdentityID[0],
          orgFlag: this.ID
        };
        let res = await updateUserInfo(obj).catch(() => {
          this.btnLoading = false;
        });
        if (res.code === 1) {
          this.serverSaveInformation();
        }
      },
      successInfo() {
        this.$message({
          type: "success",
          message: "身份设置成功",
        });
        this.btnLoading = false;
        this.$emit("setSuccess", 1);
      },
      // 保存租户关注的各项信息
      serverSaveInformation() {
        saveInformation(this.obj).then(res => {
          const { code, message } = res;
          if (code === 1) {
            this.successInfo();
          } else {
            this.$message.error(message);
          }
        });
      },
      // 服务or行业数据
      setCascaderIndustryData(industry) {
        let arr = [];
        for (let i = 0; i < industry.length; i++) {
          let item = industry[i];
          if (item && item.length) {
            arr = arr.concat({
              id: item[item.length - 1],
              path: item.toString().replace(/,/g, '/')
            });
          }
        }
        return arr;
      },
      // 点击市场
      changeService(val) {
        if (val === 3 && !this.typeObj.length) {
          getCityList().then(res => {
            let { code, data } = res;
            if (code === 1) {
              this.typeObj = getTreeData(data);
              this.typeObj.forEach(item => {
                if (item && item.children) {
                  item.children.forEach(el => {
                    if (el && el.children) {
                      el.children.forEach(e => {
                        e.children = undefined; // 外销地区不显示城市
                      });
                    }
                  });
                }
              });
            }
          })
        }
      },
      // 字典查询
      getByKeysData() {
        let parameter = ["industry"];
        parameter = this.designer ? parameter.concat("service") : parameter;
        getByKeys(parameter).then(res => {
          let {code, data} = res;
          if (code === 1) {
            this.industry = data?.industry ? getTreeData(JSON.parse(data?.industry)) : []; // 行业
            this.service = data?.service ? getTreeData(JSON.parse(data?.service)) : []; // 设计师服务类型
          }
        });
      },
      changeID(n) {
        this.ID = n;
      },
      // 身份选择
      selectIdentity: function (n) {
        this.selectIdentityID = [n]; // 单选
        // 以下为多选逻辑
        // if (!this.selectIdentityID.length) {
        //   this.selectIdentityID.push(n);
        // } else {
        //   let is = this.selectIdentityID.some(item => item === n);
        //   if (is) {
        //     this.selectIdentityID = this.selectIdentityID.filter(item => item !== n);
        //   } else {
        //     this.selectIdentityID.push(n);
        //   }
        // }
        this.designer = this.selectIdentityID.find(item => item === 1); // 是否选择设计师
      },
      nextStep() { // 下一步
        if (!this.selectIdentityID.length) {
          this.messageWarning("请选择您的身份");
        } else if (!this.ID) {
          this.messageWarning("请选择您的主体");
        } else {
          this.$emit("changeDialogShow");
        }
      },
      previousStep() { // 上一步
        this.form = {
          type: [],
          service: 1, // 市场类型，0未设置，1非典型，2内销，3外销
          industry: [], // 行业
          region: [] // 地区
        };
        this.copyTyope = [];
        this.industry = [];
        this.service = [];
        this.typeObj = [];
        this.$emit("changeDialogShow");
      },
      // 服务类型
      changeCascader1() {
        if (this.form.type.length > 10) {
          this.form.type = this.copyTyope;
          this.messageWarning("最多可以选择10个服务类型哦~");
        }
        this.copyTyope = JSON.parse(JSON.stringify(this.form.type));
      },
      messageWarning(text) {
        this.$message({
          type: "warning",
          message: text
        });
      }
    }
  }
</script>

<style lang="scss">
  .el-dialog-new-identity {
    background-image: url("../../../assets/img@2x/dialog-back.png") !important;
    background-size: 790px 197px !important;
    background-repeat: no-repeat !important;
    .el-dialog__header {
      padding: 34px 44px 35px;
    }
    .el-dialog__body {
      padding: 0 44px;
    }
    .el-dialog__footer {
      padding: 37px 44px 36px;
    }
    .new-identity {
      .label-name {
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        &:nth-child(3) {
          margin: 34px 0 18px;
        }
      }
      .select-ID-radio {
        margin-top: 18px;
        div {
          margin-right: 40px;
          cursor: pointer;
          height: 22px;
          display: inline-block;
          .icon {
            width: 16px;
            height: 16px;
            margin: 0 8px 0 0;
            box-sizing: border-box;
            vertical-align: middle;
            display: inline-block;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .Not_selected {
            border: 1px solid #D5D5D5;
            border-radius: 50%;
            background: #fff;
          }
          .text {
            font-size: 16px;
            vertical-align: middle;
            color: #1E282C;
          }
        }
      }
      .ID {
        .select-ID-ID {
          display: flex;
          justify-content: space-between;
          margin-top: 18px;
          &-info {
            width: 338px;
            height: 108px;
            border-radius: 6px;
            border: 1px solid #E8E8EB;
            background: url("../../../assets/img@2x/dialog-back-2.png") no-repeat;
            background-size: 100%;
            padding: 28px 0 0 28px;
            cursor: pointer;
            position: relative;
            .in {
              font-size: 16px;
              font-weight: 500;
              color: #202D40;
              span {
                color: #999;
                font-size: 14px;
              }
            }
            .explain {
              font-size: 14px;
              font-weight: 400;
              color: #9DA1AC;
              margin-top: 10px;
            }
            .icon {
              width: 29px;
              height: 29px;
              position: absolute;
              right: 0;
              bottom: 0;
              background: url("../../../assets/img@2x/Select-2.png") no-repeat;
              background-size: 100%;
              display: none;
            }
          }
          .active {
            border-color: #2858F8;
            .icon {
              display: block;
            }
          }
        }
      }

      .ServiceType {
        .el-form-item__content {
          .el-select {
            width: 80%;
          }
        }
      }

    }
  }
  .el-dialog-new-identity-2 {
    .el-dialog__header {
      padding: 20px 24px 26px;
    }
    .el-dialog__body {
      padding: 30px 24px;
      .el-select-1,
      .el-select-4 {
        width: 100%;
      }
      .el-select-2 {
        width: 75px;
      }
      .el-select-3 {
        width: calc(100% - 75px);
      }
      .el-form .el-form-item label .new-label {
        width: 100%;
        display: inline-flex;
        justify-content: space-between;
      }
      .el-form {
        .el-form-item {
          &:nth-child(1) {
            .el-form-item__content {
              .tips {
                position: absolute;
                right: 32px;
                top: 50%;
                transform: translateY(-50%);
                font-size: 14px;
                color: #B8BCC5;
              }
            }
          }
        }
      }
    }
    .el-dialog__footer {
      padding: 8px 24px 24px;
      .dialog-footer {
        display: flex;
        justify-content: space-between;
        .skip {
          color: #9DA1AC;
        }
      }
    }
  }
  // 限制第一级不可选， 其他级都可选（隐藏第一级checkbox）
  .el-select-4-popper .el-cascader-menu:nth-of-type(1) .el-checkbox__input {
    display: none !important;
  }
</style>